module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project_item--content-wrap",
    class: 'project_item--content__' + _vm.label
  }, [_c('h5', [_vm._v(_vm._s(_vm.label) + " ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.content))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70ebc651"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project-item-description-item/ProjectItemDescriptionItem.vue
// module id = 89
// module chunks = 0